import React from 'react';

const DashboardFilters = ({ customers, jobTypes, filters, onChange }) => (
    <div className="d-flex flex-wrap align-items-end" style={{ gap: '1rem' }}>
        <div className="form-group mb-0">
            <label htmlFor="dashboardFilterCustomer" className="mb-1">Customer</label>
            <select
                id="dashboardFilterCustomer"
                className="form-control"
                value={filters.customerId}
                onChange={(e) => onChange({ ...filters, customerId: e.target.value })}
            >
                <option value="">All customers</option>
                {customers.map((customer) => (
                    <option key={customer.id} value={customer.id}>{customer.name}</option>
                ))}
            </select>
        </div>

        <div className="form-group mb-0">
            <label htmlFor="dashboardFilterJobType" className="mb-1">Job type</label>
            <select
                id="dashboardFilterJobType"
                className="form-control"
                value={filters.jobTypeId}
                onChange={(e) => onChange({ ...filters, jobTypeId: e.target.value })}
            >
                <option value="">All job types</option>
                {jobTypes.map((jobType) => (
                    <option key={jobType.id} value={jobType.id}>{jobType.name}</option>
                ))}
            </select>
        </div>

        <div className="text-muted small">
            <i className="fas fa-info-circle"></i> Data refreshes every 5 minutes
        </div>
    </div>
);

export default DashboardFilters;
